<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="300"
    min-width="550px"
    max-width="880px"
    max-height="800px"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        outlined
        v-bind="attrs"
        v-on="on"
        class="mx-0 px-0"
        style="min-width: 30px !important"
      >
        <v-icon dense>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card outlined>
      <v-card-title class="font-weight-medium"
        ><span class="text-subtitle-1 font-weight-medium"
          >Personalakte wechseln</span
        >
        <v-spacer></v-spacer>
        <v-btn icon small @click="close()"
          ><v-icon small>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-subtitle>
        <v-text-field
          v-model="search"
          outlined
          dense
          label="Suchen"
          hide-details="auto"
          prepend-inner-icon="mdi-magnify"
          class="mt-2"
          clearable
        ></v-text-field>
        <v-select
          v-model="statusFilter"
          :items="statusValues"
          label="Nach Status filtern"
          outlined
          multiple
          dense
          required
          item-text="text"
          item-value="value"
          prepend-inner-icon="mdi-filter"
          hide-details="auto"
          class="mt-3"
        >
          <template v-slot:selection="data">
            <personnel-record-status-chip
              :status="data.item.value"
              small
              class="mr-1"
              @click="toggle"
            >
            </personnel-record-status-chip>
          </template>
        </v-select>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="listItems"
        :search="search"
        item-key="uid"
        sort-by="lastName"
        fixed-header
        height="500"
        group-by="groupByDivision"
        dense
        checkbox-color="primary"
        mobile-breakpoint="0"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
          <th :colspan="headers.length++">
            <v-icon @click="toggle" class="mr-2"
              >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
            <span>
              {{ stripPrefix(items[0].groupByDivision) }}
            </span>
          </th>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <pre>{{ item.personnelNumber }}</pre>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <personnel-record-status-chip :status="item.status" small>
          </personnel-record-status-chip>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            v-if="item.user.membershipId == $route.params.itemId"
            color="primary"
            x-small
            depressed
            label
            read-only
            class="font-weight-medium"
            >Bereits aktiv</v-btn
          >
          <span v-else>
            <v-btn x-small depressed @click="startRoute(item)" class="mr-1">
              <v-icon small>mdi-open-in-app</v-icon>
            </v-btn>
            <v-btn x-small depressed @click="startRoute(item, 'newTab')">
              <v-icon small>mdi-open-in-new</v-icon>
            </v-btn>
          </span>
        </template></v-data-table
      >
    </v-card>
  </v-menu>
</template>

<style></style>

<script>
import PersonnelRecordStatusChip from "@/components/member-management/personnel-records/PersonnelRecordStatusChip.vue";
export default {
  name: "person-switcher-selector-menu",
  props: {
    selection: {},
    items: {},
  },
  model: {
    prop: "selection",
    event: "selectionChange",
  },
  components: { PersonnelRecordStatusChip },
  computed: {
    selectionLocal: {
      get: function () {
        return this.selection;
      },
      set: function (value) {
        this.$emit("selectionChange", value);
      },
    },
    listItems() {
      return this.items
        .map((record) => {
          return {
            ...record,
            groupByDivision:
              record.division.sortKey.toString().padStart(4, "0") +
              "_" +
              record.division.title,
          };
        })
        .filter((record) => {
          return this.statusFilter.includes(record.status);
        });
    },
    defaultHeaders() {
      return this.headers.filter((header) => header.default);
    },
    defaultState() {
      return (
        this.selectionLocalBuffer.length === this.defaultHeaders.length &&
        this.selectionLocalBuffer.every((item) => item.default)
      );
    },
  },
  data() {
    return {
      menu: false,
      search: "",
      statusFilter: ["active", "onLeave", "transfer"],
      statusValues: [
        { text: "Aktiv", value: "active", color: "#4CAF50" },
        { text: "Beurlaubt", value: "onLeave", color: "#FF9800" },
        { text: "Ausgetreten", value: "resigned", color: "#795548" },
        { text: "Im Übertritt", value: "transfer", color: "#CDDC39" },
        { text: "Entlassen", value: "dismissed", color: "#F44336" },
        { text: "Verstorben", value: "deceased", color: "#9E9E9E" },
      ],
      headers: [
        {
          text: "Personalnr.",
          value: "personnelNumber",
          align: "start",
        },
        {
          text: "Vorname",
          value: "firstName",
          align: "start",
        },
        {
          text: "Nachname",
          value: "lastName",
          align: "start",
          divider: true,
        },
        {
          text: "Status",
          value: "status",
          align: "start",
          divider: true,
        },
        {
          text: "",
          value: "action",
          align: "right",
        },
      ],
    };
  },
  created() {
    this.selectionLocalBuffer = this.selectionLocal;
  },
  methods: {
    close() {
      this.menu = false;
    },
    stripPrefix(item) {
      return item.substring(item.indexOf("_") + 1);
    },
    startRoute(item, newTab) {
      if (newTab) {
        window.open(
          this.$router.resolve({
            name: this.$router.currentRoute.name,
            params: {
              ...this.$router.currentRoute.params,
              itemId: item.user.membershipId,
            },
          }).href,
          "_blank"
        );
      } else {
        this.$router.push({
          name: this.$router.currentRoute.name,
          params: {
            ...this.$router.currentRoute.params,
            itemId: item.user.membershipId,
          },
        });
      }
      this.close();
    },
  },
};
</script>
